import React from "react"

function TimelineItem(props) {
  return <div className="timeline-item">{props.children}</div>
}

export default TimelineItem
